import { Routes } from '@angular/router';
import { LayoutComponent } from 'core';
import { Permission } from 'core/enums/permission';
// AUTHENTICATION DISABLED FOR TESTING - authGuard import removed
// import { authGuard } from 'core/guards/auth.guard';
import { authRoutes } from 'features/auth/auth.routes';
import { testsRoutes } from 'features/tests/tests.routes';
import { categoriesRoutes } from 'features/categories/categories.routes';
import { pagesRoutes } from 'features/pages/pages.routes';
import { faqsRoutes } from 'features/faqs/faqs.routes';
import { formsRoutes } from 'features/forms/forms.routes';
import { formQuestionOptionTypesRoutes } from 'features/form-question-option-types/form-question-option-types.routes';
import { newsLetterRoutes } from 'features/news-letter/news-letter.routes';
import { sectionsRoutes } from 'features/sections/sections.routes';
import { pollsRoutes } from 'features/polls/polls.routes';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'tests',
    pathMatch: 'full'
  },
  {
    path: 'account',
    children: authRoutes
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: '', redirectTo: 'tests', pathMatch: 'full' },
      {
        path: 'dashboard',
        // AUTHENTICATION DISABLED FOR TESTING - canActivateChild removed
        data: { isAnonymous: true },
        loadComponent: () => import('./features/dashboard/pages/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'tests',
        // AUTHENTICATION DISABLED FOR TESTING - canActivateChild removed
        data: { permission: Permission.ViewTests },
        children: testsRoutes
      },
      {
        path: 'settings',
        // AUTHENTICATION DISABLED FOR TESTING - canActivateChild removed
        data: { permission: Permission.ViewCategories },
        children: [
          {
            path: 'general-settings',
            loadChildren: () => import('./features/settings/general-settings/general-settings.routes').then(m => m.generalSettingsRoutes)
          },
          {
            path: 'categories',
            loadChildren: () => import('./features/settings/categories/categories.routes').then(m => m.categoriesRoutes)
          },
          {
            path: 'languages',
            loadChildren: () => import('./features/settings/languages/languages.routes').then(m => m.languagesRoutes)
          }
        ]
      },
      {
        path: 'categories',
        // AUTHENTICATION DISABLED FOR TESTING - canActivateChild removed
        data: { permission: Permission.ViewCategories },
        children: categoriesRoutes
      },
      {
        path: 'pages',
        // AUTHENTICATION DISABLED FOR TESTING - canActivateChild removed
        data: { permission: Permission.ViewCategories },
        children: pagesRoutes
      },
      {
        path: 'faqs',
        // AUTHENTICATION DISABLED FOR TESTING - canActivateChild removed
        data: { isAnonymous: true },
        children: faqsRoutes
      },
      {
        path: 'form-question-option-types',
        // AUTHENTICATION DISABLED FOR TESTING - canActivateChild removed
        data: { isAnonymous: true },
        children: formQuestionOptionTypesRoutes
      },
      {
        path: 'forms',
        // AUTHENTICATION DISABLED FOR TESTING - canActivateChild removed
        data: { isAnonymous: true },
        children: formsRoutes
      },
      {
        path: 'news-letter',
        // AUTHENTICATION DISABLED FOR TESTING - canActivateChild removed
        data: { isAnonymous: true },
        children: newsLetterRoutes
      },
      {
        path: 'polls',
        // AUTHENTICATION DISABLED FOR TESTING - canActivateChild removed
        data: { isAnonymous: true },
        children: pollsRoutes
      },
      {
        path: 'sections',
        // AUTHENTICATION DISABLED FOR TESTING - canActivateChild removed
        data: { permission: Permission.ViewCategories },
        children: sectionsRoutes
      }
    ]
  },
  { path: 'error/:errorNumber', loadComponent: () => import('./core/components/error/error.component').then(m => m.ErrorComponent) },
  { path: '**', redirectTo: '/error/404' }
];
